<template>
    <v-card>
        <v-card-title>会員数状況:担当CO別</v-card-title>
        <v-card-text>
            <v-sheet tile height="6vh" class="d-flex align-center">
                <v-container>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col lg="3" sm="6" cols="12">
                            <v-select
                                v-model="target_month"
                                :items="monthes"
                                label="期間"
                                @change="changeMonth"
                                style="min-width: min-content;"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-sheet>
            <v-card class="mb-6">
                <v-card-subtitle>
                全体
                </v-card-subtitle>
                <v-card-text>
                    <v-data-table
                        :headers="headersActive"
                        :items="all"
                        :server-items-length="all.length"
                        :loading="loading"
                        hide-default-footer
                        dense
                    >
                    </v-data-table>
                </v-card-text>
                <v-card-subtitle>
                新規入会
                </v-card-subtitle>
                <v-card-text>
                    <v-data-table
                        :headers="headersActive"
                        :items="contract"
                        :server-items-length="contract.length"
                        :loading="loading"
                        hide-default-footer
                        dense
                    >
                    </v-data-table>
                </v-card-text>
                <v-card-subtitle>
                休止会員
                </v-card-subtitle>
                <v-card-text>
                    <v-data-table
                        :headers="headersActive"
                        :items="rest"
                        :server-items-length="rest.length"
                        :loading="loading"
                        hide-default-footer
                        dense
                    >
                    </v-data-table>
                </v-card-text>
            </v-card>
            <v-card>
                <v-card-subtitle>
                非活動会員
                </v-card-subtitle>
                <v-card-text>
                <v-data-table
                    :headers="headersInactive"
                    :items="inactive"
                    :server-items-length="inactive.length"
                    :loading="loading"
                    hide-default-footer
                    dense
                >
                    <template v-slot:header="">
                        <thead>
                        <tr>
                            <th colspan="2"></th>
                            <th style="text-align: center">退会予備状態数</th>
                            <th colspan="2" style="text-align: center">退会数</th>
                            <th colspan="2" style="text-align: center">満期退会数</th>
                            <th colspan="2" style="text-align: center">中途退会数</th>
                            <th colspan="2" style="text-align: center">成婚退会数</th>
                        </tr>
                        </thead>
                    </template>
                </v-data-table>
                </v-card-text>
            </v-card>
        </v-card-text>
    </v-card>
</template>

<style scoped>
.v-data-table >>> th:not(:last-child),.v-data-table >>> td:not(:last-child) {
        border-right: thin solid rgba(0,0,0,.12);
}
</style>
<script>
export default {
    title: "会員数状況:担当CO別",
    name: "customer_count_co",
    data: () => ({
        target_month: 0,
        loading: false,
        headersInactive: [
            { text: "担当CO", value: "counselor", align: "center", sortable: false },
            { text: "支店", value: "shop", align: "center", sortable: false },
            { text: "男", value: "reserve_m", align: "center", sortable: false },
            { text: "男", value: "exit_m", align: "center", sortable: false },
            { text: "女", value: "exit_f", align: "center", sortable: false },
            { text: "男", value: "full_m", align: "center", sortable: false },
            { text: "女", value: "full_f", align: "center", sortable: false },
            { text: "男", value: "half_m", align: "center", sortable: false },
            { text: "女", value: "half_f", align: "center", sortable: false },
            { text: "男", value: "marriage_m", align: "center", sortable: false },
            { text: "女", value: "marriage_f", align: "center", sortable: false }
        ],
        courses: [],
        all: [],
        contract: [],
        rest: [],
        inactive: [],
    }),
    async mounted() {
        this.target_month = this.monthes[0].value;
        await this.getList();
    },
    computed: {
        monthes() {
            const monthes = [];
            const now = new Date();
            
            let year = now.getFullYear();
            let month = now.getMonth() + 1;
            
            while(year > 2021 || month >= 6) {
                monthes.push({
                    text: `${year}年${month}月`,
                    value: `${year}-${("00"+month).slice(-2)}`
                });
                --month;
                if(month <= 0) {
                    --year;
                    month = 12;
                }
            }

            return monthes;
        },
        headersActive() {
            const headers = [
                { text: "担当CO", value: "counselor", align: "start", sortable: false },
                { text: "支店", value: "shop", align: "start", sortable: false },
                { text: "合計", value: "total", align: "center", sortable: false },
            ];
            this.courses.forEach(c => {
                headers.push({
                    text: c.text,
                    value: `c${c.value}`,
                    align: "center",
                    sortable: false
                });
            })
            headers.push({ text: "男", value: "m", align: "center", sortable: false });
            headers.push({ text: "女", value: "f", align: "center", sortable: false });

            return headers;
        },
    },
    methods: {
        async getList() {
            this.loading = true;

            await this.$axios.get( `/api/v1/customer_count/co/${this.target_month}`)
                .then( response => {
                    this.all = response.data.all.map( d => {
                        const counselor = response.data.counselors.find(c => c.value == d.counselor_id)
                        d.counselor = counselor.text;
                        const shop = response.data.shops.find(s => s.value == d.shop_id);
                        d.shop = shop ? shop.text : "不明";
                        return d;
                    })
                    this.all.push(this.getTotalLine(this.all))
                    this.contract = response.data.contract.map( d => {
                        const counselor = response.data.counselors.find(c => c.value == d.counselor_id)
                        d.counselor = counselor.text;
                        const shop = response.data.shops.find(s => s.value == d.shop_id);
                        d.shop = shop ? shop.text : "不明";
                        return d;
                    })
                    this.contract.push(this.getTotalLine(this.contract))
                    this.rest = response.data.rest.map( d => {
                        const counselor = response.data.counselors.find(c => c.value == d.counselor_id)
                        d.counselor = counselor.text;
                        const shop = response.data.shops.find(s => s.value == d.shop_id);
                        d.shop = shop ? shop.text : "不明";
                        return d;
                    })
                    this.rest.push(this.getTotalLine(this.rest))

                    this.inactive = response.data.inactive.map( d => {
                        const counselor = response.data.counselors.find(c => c.value == d.counselor_id)
                        d.counselor = counselor.text;
                        const shop = response.data.shops.find(s => s.value == d.shop_id);
                        d.shop = shop ? shop.text : "不明";
                        return d;
                    })
                    this.inactive.push(this.getTotalLine(this.inactive))

                    this.courses = response.data.courses;
                })
                .catch( error => {
                    console.log(error);
                });
            this.loading = false;
        },
        changeMonth() {
            this.getList();
        },
        getTotalLine(data) {
            const ret = {}
            data.forEach(d => {
                Object.keys(d).forEach(key => {
                    if(!ret[key]) ret[key] = 0;
                    ret[key] += d[key];
                });
            });
            ret.counselor = "全体";
            ret.shop = "";
            return ret;
        },
    },
};
</script>
